import axios from 'axios';

// Function to initialize Axios client
const createApiClient = (token) => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_SUPABASE_BASE_URI,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
      'x-user-jwt': token
    }
  });

  // console.log('Base URL:', client.defaults.baseURL); // Optional: Debug
  return client;
};


// --- Client Workflows API Calls ---

export const listClientWorkflowsAsync = (token) => {
  return createApiClient(token).get(`/clientworkflow-list/`);
};
export const listWorkflowsAsync = (token) => {
  return createApiClient(token).get(`/workflow-list/`);
};

export const listWorkflowRunsAsync = (token, workflow_name, page, pageSize) => {
  return createApiClient(token).get(`/clientworkflow-scheduledruns-list/${workflow_name}/${page}/${pageSize}`);
};

// --- Payment Method API Calls ---

export const getPaymentMethodAsync = (token) => {
  return createApiClient(token).get(`/payment-list/`);
};

export const savePaymentMethodAsync = (token, payload) => {
  return createApiClient(token).post(`/payment-upsert/`, payload);
};

export const deletePaymentMethodAsync = (token) => {
  return createApiClient(token).delete(`/payment-remove/`, { data: {} });
};

export const createSubscriptionAsync = (token, payload) => {
  return createApiClient(token).post(`/stripe-subscription-create/`, payload);
};

export const cancelSubscriptionAsync = (token, payload) => {
  return createApiClient(token).post(`/stripe-subscription-cancel/`, payload);
};
